import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import LoadingOverlay from "./LoadingOverlay";
import { useAppLoading } from "../context/AppLoadingContext";
import {
  isOwnerAwaitingPropertyApproval,
  isOwnerPropertyPending,
  ownerRestrictedHomePath,
  PROPERTY_INFO_CHANGED_EVENT,
  readPropertyInfo
} from "../utils/propertyAccess";

const Layout = () => {
    const { isLoading } = useAppLoading();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const [propertyInfo, setPropertyInfo] = useState(() => readPropertyInfo());

    useEffect(() => {
        const sync = () => setPropertyInfo(readPropertyInfo());
        window.addEventListener("storage", sync);
        window.addEventListener(PROPERTY_INFO_CHANGED_EVENT, sync);
        return () => {
            window.removeEventListener("storage", sync);
            window.removeEventListener(PROPERTY_INFO_CHANGED_EVENT, sync);
        };
    }, []);
    const ownerPending = isOwnerPropertyPending(role, propertyInfo);
    const ownerAwaitingApproval = isOwnerAwaitingPropertyApproval(role, propertyInfo);
    const onAddPage = location.pathname.startsWith("/property-details-add");
    const onPropertyPage =
      location.pathname === "/property-details" ||
      onAddPage ||
      location.pathname.startsWith("/property-details-edit");

    if (ownerPending && !onAddPage) {
      return <Navigate to="/property-details-add" replace />;
    }
    if (ownerAwaitingApproval && !onPropertyPage) {
      return <Navigate to={ownerRestrictedHomePath(role, propertyInfo)} replace />;
    }

    return (
        <div className="wrapper">
            <Header />
            <Sidebar />
            <div className="content-wrapper" style={{ position: "relative" }}>
                <LoadingOverlay open={isLoading} variant="content" />
                <Outlet />
            </div>
            <Footer />
        </div>
    );
};

export default Layout;